var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.338 2.18a1.277 1.277 0 0 0-1.582.745C45.5 11.12 25.414 61.83 21.977 70.515A1.26 1.26 0 0 0 22 71.529c.16.32.432.563.762.673.603.196 1.32.428 1.9.618a1.276 1.276 0 0 0 1.583-.745c3.243-8.194 23.342-58.905 26.779-67.588A1.261 1.261 0 0 0 53 3.472a1.38 1.234 0 0 0-.763-.672l-1.9-.62z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlash);
export default __webpack_public_path__ + "static/media/slash.41e9a80acbdff28195c4c831c99ec576.svg";
export { ForwardRef as ReactComponent };